import classNames from 'clsx';
import React, { useContext } from 'react';

import { CMSContext, CMSIconsGrid, CMSReference } from '@swf/cms';
import type { GlobalFieldReference, IconsGrid } from '@swf/generated/cms/types';
import type { IconsGridBlock } from '@swf/generated/cms/types/ProspectHomepageSlide';

import styles from './CardContentItem.scss';

interface Props {
  item: GlobalFieldReference | IconsGridBlock;
  className?: string;
}

const CardContentItem: React.FC<Props> = ({ item, className }) => {
  const cmsContext = useContext(CMSContext);
  const [[type, value]] = Object.entries(item);
  const itemClassNames = [styles.contentItem];

  if (type === 'cta') {
    value.grow = true;
    itemClassNames.push(styles.blockCta);
  } else if (type === 'html') {
    itemClassNames.push(styles.blockHtml);
  } else if (type === 'icons_grid') {
    const iconsGrid = cmsContext[value.reference[0].uid] as IconsGrid;
    return (
      <div className={classNames(styles.contentItem, className)}>
        <CMSIconsGrid {...iconsGrid} />
      </div>
    );
  }

  value.className = classNames(itemClassNames, className);

  return <CMSReference {...(item as GlobalFieldReference)} />;
};

export default CardContentItem;
